var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandCloseIcon = function SvgExpandCloseIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68345 4.2659L1.05198 0.114336C0.945682 0.0396533 0.825133 0.000227927 0.702385 9.85313e-07C0.579637 -0.000225956 0.458989 0.0387534 0.352502 0.113043C0.246014 0.187333 0.157416 0.294331 0.0955622 0.423343C0.0337086 0.552355 0.00076643 0.698861 2.81054e-05 0.84822V9.14281C-0.00108344 9.2939 0.0307938 9.44264 0.0924016 9.57383C0.154009 9.70502 0.243139 9.81395 0.35068 9.88949C0.457953 9.96197 0.578631 10 0.701332 10C0.824032 10 0.94471 9.96197 1.05198 9.88949L6.66241 5.73793C6.76547 5.66187 6.85067 5.55477 6.9098 5.42697C6.96894 5.29917 7 5.15498 7 5.00831C7 4.86165 6.96894 4.71746 6.9098 4.58966C6.85067 4.46186 6.76547 4.35476 6.66241 4.2787L6.68345 4.2659Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "expandCloseIcon.c3d61e076252e98755fe33beadfeda0b.svg";